import { Suspense, lazy, type ComponentProps } from 'react'
import type { AgreementBuilder as AgreementBuilderNow } from './agreements/AgreementBuilder.js'
import { LoadingPanel } from './Loader.js'
import type { ProposalBuilder as ProposalBuilderNow } from './proposal/ProposalBuilder.js'

/*
 * The two builders, fetched the moment one opens.
 *
 * Between them they are eight thousand lines — the proposal canvas with its
 * blocks, inspectors and drag, and the agreement wizard — and every job card
 * imported both, so a technician's phone downloaded them to read a note. The
 * props are the builders' own; closed, these draw nothing and fetch nothing.
 */

const ProposalChunk = lazy(() =>
  import('./proposal/ProposalBuilder.js').then((module) => ({ default: module.ProposalBuilder })),
)
const AgreementChunk = lazy(() =>
  import('./agreements/AgreementBuilder.js').then((module) => ({ default: module.AgreementBuilder })),
)

export function ProposalBuilder(props: ComponentProps<typeof ProposalBuilderNow>) {
  if (!props.open) return null
  return (
    <Suspense fallback={<Arriving />}>
      <ProposalChunk {...props} />
    </Suspense>
  )
}

export function AgreementBuilder(props: ComponentProps<typeof AgreementBuilderNow>) {
  if (!props.open) return null
  return (
    <Suspense fallback={<Arriving />}>
      <AgreementChunk {...props} />
    </Suspense>
  )
}

/** The scrim the builder will sit on, with the loader, for the moment it takes. */
function Arriving() {
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-ink-900/40">
      <LoadingPanel className="max-w-xs rounded-lg bg-white" />
    </div>
  )
}
